import { useState } from "react";
import apiClient from "../../../shared/API/apiClient";

const MarkReviewedModal = ({
  onClose,
  onConfirm,
  submission_id,
  reportingYearId,
  principle_id,
  apiUrl,               // ← NEW: caller passes the endpoint
}) => {
  const [comment,      setComment]      = useState("");
  const [submitting,   setSubmitting]   = useState(false);
  const [apiError,     setApiError]     = useState("");
  const [commentError, setCommentError] = useState(false);

  const handleConfirm = async () => {
    if (!comment.trim()) {
      setCommentError(true);
      return;
    }
    setSubmitting(true);
    setApiError("");
    try {
      await apiClient.post(apiUrl, {
        submission_id,
        reporting_year_id: reportingYearId,
        principle_id,
        reviewer_comment: comment,
      });
      onConfirm();
      onClose();
    } catch (err) {
      console.error("Modal action error:", err);
      setApiError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rv-modal-overlay" onClick={onClose}>
      <div className="rv-modal" onClick={(e) => e.stopPropagation()}>
        <div className="rv-modal__body">
          <label className="rv-modal__label">
            Reviewer Comment <span className="rv-modal__required">*</span>
          </label>
          <textarea
            className={`rv-modal__textarea${commentError ? " rv-modal__textarea--error" : ""}`}
            placeholder="Add a comment for this review."
            value={comment}
            rows={5}
            disabled={submitting}
            onChange={(e) => {
              setComment(e.target.value);
              if (e.target.value.trim()) setCommentError(false);
            }}
          />
          {commentError && (
            <p className="rv-modal__hint">
              A reviewer comment is mandatory to move this submission to the next workflow status.
            </p>
          )}
          {apiError && (
            <p className="rv-modal__hint" style={{ color: "#dc2626" }}>{apiError}</p>
          )}
        </div>
        <div className="rv-modal__footer">
          <button className="rv-btn rv-btn--ghost" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button
            className="rv-btn rv-btn--sendback"
            style={{ backgroundColor: "#111827", color: "#fff" }}
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting
              ? <><span className="va-action-btn__spinner" /> Processing…</>
              : <><i className="fa-solid fa-circle-check" /> Confirm</>
            }
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkReviewedModal;